import { render, staticRenderFns } from "./CategoryAdviserSelector.vue?vue&type=template&id=a533bbf6"
import script from "./CategoryAdviserSelector.vue?vue&type=script&lang=js"
export * from "./CategoryAdviserSelector.vue?vue&type=script&lang=js"
import style0 from "./CategoryAdviserSelector.vue?vue&type=style&index=0&id=a533bbf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports